(async () => {
    const LoadingIcon = (await import('./LoadingIcon')).default;
    $(() => {
        LoadingIcon(false);
        window.addEventListener('beforeunload', () => {
            LoadingIcon(true);
            window.setTimeout(() => LoadingIcon(false), 30000); // don't keep spinning forever
        });
    });
})().catch(e => {
    throw e;
});
